import { IntegrationOrderType, IntegrationOrderVo, SortColDef } from "@/types";
import { formatToLATime } from "@/utils/date";
import { ICellRendererParams } from "ag-grid-community";
import { Button, Tag } from "antd";
import {
  getShippingMethod,
  IntegrationOrderStatusColorMap,
  IntegrationOrderTypeColorMap,
} from "./const";
import { LinkOutlined } from "@ant-design/icons";

export const IntegrationOrderCols: SortColDef<IntegrationOrderVo>[] = [
  // {
  //   headerName: "RII No",
  //   field: "customerNumber",
  //   resizable: true,
  //   pinned: "left",
  //   minWidth: 200,
  //   maxWidth: 280,
  //   suppressMenu: true,
  //   rowDrag: false,
  //   cellRenderer: (row: ICellRendererParams<IntegrationOrderVo, string>) => (
  //     <LinkColumn
  //       row={row}
  //       getLink={() => `#`}
  //       buttonType="button"
  //       onLinkButtonClick={() => {
  //         console.log("onLinkButtonClick", row.data);
  //       }}
  //     />
  //   ),
  // },
  {
    headerName: "Type",
    resizable: false,
    maxWidth: 80,
    minWidth: 80,
    suppressMenu: true,
    cellRenderer: ({
      data,
    }: ICellRendererParams<IntegrationOrderVo, number>) => (
      <Tag color={IntegrationOrderTypeColorMap[data!.type]}>{data!.type}</Tag>
    ),
    rowDrag: false,
  },
  {
    headerName: "Status",
    resizable: false,
    maxWidth: 130,
    minWidth: 130,
    suppressMenu: true,
    rowDrag: false,
    sortKey: "status",
    cellRenderer: ({
      data,
    }: ICellRendererParams<IntegrationOrderVo, number>) => (
      <Tag color={IntegrationOrderStatusColorMap[data!.status]}>
        {data!.status}
      </Tag>
    ),
  },
  {
    headerName: "Customer",
    field: "customerName",
    resizable: true,
    minWidth: 100,
    suppressMenu: true,
    rowDrag: false,
  },
  {
    headerName: "Cube Order",
    field: "cubeOrderId",
    resizable: true,
    minWidth: 100,
    maxWidth: 100,
    suppressMenu: true,
    rowDrag: false,
  },
  {
    headerName: "Warehouse",
    field: "warehouseCode",
    resizable: true,
    minWidth: 120,
    suppressMenu: true,
    rowDrag: false,
  },
  {
    headerName: "Cube Order",
    resizable: true,
    minWidth: 110,
    maxWidth: 110,
    suppressMenu: true,
    rowDrag: false,
    cellRenderer: ({
      data,
    }: ICellRendererParams<IntegrationOrderVo, string>) => {
      return (
        <Button
          size="small"
          type="link"
          className="!ml-[-4px]"
          icon={<LinkOutlined />}
          onClick={() => {
            if (data?.type === IntegrationOrderType.Customer) {
              window.open(
                `http://oms.riiexpress.com/invoiceHistoryInf/${data.cubeOrderId}`,
                "_blank",
              );
            } else {
              window.open(
                `http://oms.riiexpress.com/bigOutsDetails/${data!.cubeOrderId}`,
                "_blank",
              );
            }
          }}
        >
          Cube
        </Button>
      );
    },
  },
  {
    headerName: "Ship Method",
    resizable: true,
    minWidth: 100,
    suppressMenu: true,
    rowDrag: false,
    cellRenderer: ({ data }: ICellRendererParams<IntegrationOrderVo, number>) =>
      getShippingMethod(data!.customerName, data!.shippingMethod),
  },
  {
    headerName: "Created At",
    field: "createdAt",
    minWidth: 180,
    suppressMenu: true,
    sortKey: "created_at",
    initialSort: "desc",
    cellRenderer: ({
      value,
    }: ICellRendererParams<IntegrationOrderVo, string>) =>
      value && formatToLATime(value),
  },
  {
    headerName: "Updated At",
    field: "updatedAt",
    minWidth: 180,
    suppressMenu: true,
    cellRenderer: ({
      value,
    }: ICellRendererParams<IntegrationOrderVo, string>) =>
      value && formatToLATime(value),
  },
];
